interface LogoProps {
  size?: number;
  className?: string;
}

const Logo = ({ size = 40, className = '' }: LogoProps) => {
  return (
    <svg data-component-id="src/components/ui/Logo.tsx:8:4" data-component-path="src/components/ui/Logo.tsx" data-component-line="8" data-component-end-line="36" data-component-file="Logo.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D"
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background circle */}
      <circle data-component-id="src/components/ui/Logo.tsx:17:6" data-component-path="src/components/ui/Logo.tsx" data-component-line="17" data-component-end-line="17" data-component-file="Logo.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="50" cy="50" r="48" fill="#c43e41" opacity="0.1" />

      {/* Main geometric angular design - left triangle */}
      <path data-component-id="src/components/ui/Logo.tsx:20:6" data-component-path="src/components/ui/Logo.tsx" data-component-line="20" data-component-end-line="20" data-component-file="Logo.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M25 35 L40 50 L25 65 Z" fill="#c43e41" opacity="0.9" />

      {/* Center angular shape */}
      <path data-component-id="src/components/ui/Logo.tsx:23:6" data-component-path="src/components/ui/Logo.tsx" data-component-line="23" data-component-end-line="23" data-component-file="Logo.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M40 30 L60 30 L70 50 L60 70 L40 70 L30 50 Z" fill="#eba977" />

      {/* Right triangle */}
      <path data-component-id="src/components/ui/Logo.tsx:26:6" data-component-path="src/components/ui/Logo.tsx" data-component-line="26" data-component-end-line="26" data-component-file="Logo.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M75 35 L75 65 L60 50 Z" fill="#38385e" opacity="0.9" />

      {/* Inner accent - small diamond */}
      <path data-component-id="src/components/ui/Logo.tsx:29:6" data-component-path="src/components/ui/Logo.tsx" data-component-line="29" data-component-end-line="29" data-component-file="Logo.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M50 40 L55 50 L50 60 L45 50 Z" fill="white" />

      {/* Top accent line */}
      <path data-component-id="src/components/ui/Logo.tsx:32:6" data-component-path="src/components/ui/Logo.tsx" data-component-line="32" data-component-end-line="32" data-component-file="Logo.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M45 25 L55 25 L50 35 Z" fill="#c43e41" />

      {/* Bottom accent line */}
      <path data-component-id="src/components/ui/Logo.tsx:35:6" data-component-path="src/components/ui/Logo.tsx" data-component-line="35" data-component-end-line="35" data-component-file="Logo.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M45 75 L55 75 L50 65 Z" fill="#c43e41" />
    </svg>
  );
};

export default Logo;
